export const getMenuMapping = hrefConfig => {
  const keyMap = hrefConfig.languages.reduce(
    (keyObj, { language, isDefault, links }) => {
      if (isDefault) {
        keyObj['defaultLanguage'] = language;
      }
      keyObj[language] = links.reduce((linksObj, { key, href }) => {
        linksObj[href] = key;
        return linksObj;
      }, {});
      return keyObj;
    },
    {}
  );

  return keyMap;
};

export const getKey = (href, keyMap, language) => {
  let key = null;
  const { defaultLanguage } = keyMap;
  if (language && keyMap[language] && keyMap[language][href]) {
    key = keyMap[language][href];
  } else if (
    defaultLanguage &&
    keyMap[defaultLanguage] &&
    keyMap[defaultLanguage][href]
  ) {
    key = keyMap[defaultLanguage][href];
  }
  return key;
};

export const getKeyByValue = (value, keyMap, language) => {
  const { defaultLanguage } = keyMap;
  const mapping =
    keyMap[language || defaultLanguage] || keyMap[defaultLanguage];

  if (mapping) {
    return Object.keys(mapping).find(key => mapping[key] === value);
  }

  return null;
};
